import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./menu_section_header_type.js";
//#region src/menu_section_header_type_helper.ts
var menu_section_header_type_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(displayType) {
	switch (displayType) {
		case "image": return "Image only";
		case "image-and-text": return "Image and Text Vertical";
		case "text": return "Text only";
		case "image-and-text-horizontal": return "Image and Text Horizontal";
	}
}
//#endregion
export { menu_section_header_type_helper_exports, name };

//# sourceMappingURL=menu_section_header_type_helper.js.map